let profile = null
let request = null

export function getUserProfile(ajax, forceRefresh = false) {
  if (profile && !forceRefresh) return Promise.resolve(profile)

  if (!request) {
    request = ajax.get('api/v1/users/me').then(res => {
      profile = res.data || {}
      return profile
    }).catch(err => {
      throw err
    })
    request.then(() => { request = null }, () => { request = null })
  }

  return request
}

export function clearUserProfile() {
  profile = null
  request = null
}



// WEBPACK FOOTER //
// ./src/config/userProfile.js